const truncateName = (name, length = 7) => {
  const dot = name.length > length ? '.' : '';

  return name.substring(0, length) + dot;
};

export default truncateName;
